import clsx from "clsx";

import BackgroundVideo from "./BackgroundVideo";
import styles from "./SectionWrapper.module.scss";
import SmartImage from "./SmartImage";

export default function SectionWrapper({
  background,
  backgroundPosition,
  backgroundPositionMobile,
  backgroundVideo,
  backgroundVideoPoster,
  className,
  children,
  id,
  priority,
}) {
  const hasVideo = Boolean(backgroundVideo);
  const desktopPosition = backgroundPosition || "center";
  const mobilePosition = backgroundPositionMobile || desktopPosition;

  const sectionStyle = {
    "--section-background-position-desktop": desktopPosition,
    "--section-background-position-mobile": mobilePosition,
  };

  const shouldRenderMedia = hasVideo || Boolean(background);

  return (
    <section id={id} className={clsx(className, styles.root, hasVideo && styles.hasVideo)} style={sectionStyle}>
      {shouldRenderMedia && (
        <div className={styles.backgroundMedia} aria-hidden>
          {hasVideo && (
            <BackgroundVideo
              className={styles.backgroundVideo}
              src={backgroundVideo}
              poster={backgroundVideoPoster}
              priority={Boolean(priority)}
            />
          )}
          {background && (
            <div className={styles.backgroundImage}>
              <SmartImage
                src={background}
                alt=""
                fill
                style={{ objectFit: "cover", objectPosition: "var(--section-background-position-current)" }}
                priority={Boolean(priority)}
                loading={priority ? "eager" : undefined}
                fetchPriority={priority ? "high" : undefined}
                sizes="100vw"
              />
            </div>
          )}
        </div>
      )}
      {children}
    </section>
  );
}
